import Firebase from 'firebase'
const config = {
  apiKey: "AIzaSyA2f-uG3Rqs09RdvbjG84qGj19egzJ-NQw",
  authDomain: "twill-ed69e.firebaseapp.com",
  databaseURL: "https://twill-ed69e.firebaseio.com",
  projectId: "twill-ed69e",
  storageBucket: "twill-ed69e.appspot.com",
  messagingSenderId: "667859229177"
  };
  
const app = Firebase.initializeApp(config);
export const db = app.database();


// WEBPACK FOOTER //
// ./src/firebase.js